import type { TriggerTagCondition as TriggerTagConditionType } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { RuleTagPicker } from "../../rule-tag-picker";
import * as styles from "./conditions.module.css";

export const TriggerTagCondition = memo(function TriggerTagCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: TriggerTagConditionType;
  onChange: (updated: TriggerTagConditionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const { t } = useTranslation();
  const tagsEditable =
    editableFields === undefined || editableFields.has("tags");

  return (
    <Flex dir="column" gap="sm" w="full">
      <Flex className={tagsEditable ? undefined : styles.tagInputDisabled}>
        <RuleTagPicker
          addButtonLabel={t("Select tag")}
          onChange={(names) => {
            if (!tagsEditable) {
              return;
            }
            onChange({ ...condition, tags: names });
          }}
          selectedTagNames={condition.tags ?? []}
        />
      </Flex>
    </Flex>
  );
});
